import React, { useState, useEffect } from 'react';
import { IoMdClose } from 'react-icons/io'; 

type PopupBannerProps = {
  onClose: () => void;
};

const PopupBanner: React.FC<PopupBannerProps> = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolling, setIsScrolling] = useState(false);
  const [isDimmed, setIsDimmed] = useState(false); // Track dimmed state

  const newBannerSrc = '/IOTBIZ_POPUP.jpg'; 

  useEffect(() => {
    const isBannerClosed = localStorage.getItem('popupBannerClosed');
    if (isBannerClosed === 'true') {
      setIsVisible(false); 
    }

    const lastClosedTime = localStorage.getItem('popupClosedTime');
    if (lastClosedTime) {
      const currentTime = new Date().getTime();
      const threeHours = 1* 60 * 1000;
      const timeDifference = currentTime - parseInt(lastClosedTime, 10);
      if (timeDifference < threeHours) {
        onClose();
        setIsVisible(false); 
      } else {
        setIsVisible(true); 
      }
    }
  }, []);

  useEffect(() => {
    let prevScrollY = window.pageYOffset;

    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;
      const isScrollingUp = currentScrollY < prevScrollY;

      setIsScrolling(true); 
      setTimeout(() => setIsScrolling(false), 500); 

      prevScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleImageClick = () => {
    window.location.href = 'https://iot.dxhub.co.jp/lp';
  };

  const handleClose = () => {
    setIsVisible(false);
    onClose();
    localStorage.setItem('popupBannerClosed', 'true');
    const currentTime = new Date().getTime();
    localStorage.setItem('popupClosedTime', currentTime.toString()); 
  };

  return (
    <>
      {/* Dimmed background overlay */}
      {isDimmed && <div className="overlay" onClick={() => setIsDimmed(false)}></div>}

      <div 
        className={`popup-banner ${isVisible ? '' : 'fade-out'} ${isScrolling ? 'fade-out' : ''}`} 
        onMouseEnter={() => setIsDimmed(true)} 
        onMouseLeave={() => setIsDimmed(false)}
      >
        <a href="https://mvno.dxhub.co.jp/">
          <img src={newBannerSrc} alt="New Banner" />
        </a>
      </div>
    </>
  );
}

export default PopupBanner;
